<template>
  <b-form inline @submit.prevent="emitSearch">
    <label class="sr-only" for="search-input"> {{ $t("common.search") }}</label>

    <b-input-group id="fieldset-horizontal" class="col-md-7">
      <b-button
        class="mr-3 esep-blue-bg"
        type="submit"
        variant="primary"
        :disabled="this.searchString.length < 3"
      >
        {{ $t("common.search") }}
      </b-button>
      <b-input-group-prepend is-text>
        <b-icon icon="search" />
      </b-input-group-prepend>
      <b-input
        id="search-input"
        v-model="searchString"
        :placeholder="$t('roleManagement.searchBar')"
      />
    </b-input-group>

  </b-form>
</template>
<script>

export default {
  name: "role-management-search",
  data() {
    return {
      searchString: "",
    };
  },
  methods: {
    emitSearch() {
      this.$emit("search-string-changed", this.searchString);
    }
  },
};
</script>